import React, { FC, useEffect } from 'react';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import Swal from 'sweetalert2';
import { StoreReturnCommand } from '../../../services/command';
import { useTranslation } from 'react-i18next';
import { SCUIGeneralDrawerHeader } from '../../../atomic/molecules';
import { StoreReturnQuery } from '../../../services/query';
import { SCS } from '../storeCustomerService.classes';

interface IProps {
    selectedRow?: any;
    onCloseMenu?: any;
}

export const SCUICustomerDecisionDrawerContent: FC<IProps> = ({ selectedRow, onCloseMenu }) => {
    const { t } = useTranslation();
    const [datas, setDatas] = React.useState<any>([]);
    const [musteriIadeUrun, setMusteriIadeUrun] = React.useState<any>([]);

    useEffect(() => {
        GetCustomerDecision();
        GetMusteriIade();
    }, []);

    const GetCustomerDecision = async () => {
        let params: any = {
            storeCode: selectedRow?.magazaKod,
            returnId: selectedRow?.iadeKayitNo,
        };
        StoreReturnCommand.GetCustomerDecision(params)
            .then((res: any) => {
                setDatas(res);
            })
            .catch((error: any) => {
                Swal.fire(t('general.error'), ' ', 'warning');
                console.log('Hata :>> ', error);
            });
    };

    const GetMusteriIade = async () => {
        let params: any = {
            storeCode: selectedRow?.magazaKod,
            returnId: selectedRow?.iadeKayitNo,
        };
        StoreReturnQuery.GetMusteriIadeUrun(params)
            .then((res: any) => {
                setMusteriIadeUrun(res.data);
            })
            .catch((error: any) => {
                Swal.fire(t('general.error'), ' ', 'warning');
                console.log('Hata :>> ', error);
            });
    };

    return (
        <Grid container sx={{ paddingTop: '2rem' }} className={SCS.decision}>
            <Box className={SCS.decisionHeader}>
                <SCUIGeneralDrawerHeader header={'Kararlar'} onClose={onCloseMenu} />
            </Box>
            {datas &&
                datas.map((product: any, index: number) => (
                    <Grid
                        key={index}
                        className={SCS.decisionCardWrapper}
                        data-decision-index={index}
                        data-decision-barkod={product?.barkod}
                        sx={{ margin: 1, padding: 1 }}
                        size={{
                            xl: 12,
                            lg: 12,
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <Card sx={{ minWidth: 450 }} className={SCS.decisionCard}>
                            Karar : {index + 1 + ' / ' + datas.length}
                            <CardContent className={SCS.decisionCardContent}>
                                <Typography
                                    variant="body2"
                                    sx={{ marginBottom: 0.5 }}
                                    className={`${SCS.decisionField} ${SCS.decisionFieldOzelKod}`}
                                    data-ozel-kod={product?.ozelKod1}
                                    data-renk={product?.renk}
                                >
                                    <b> ÖzelKod1&nbsp;:&nbsp;</b>
                                    {product.ozelKod1 + ' - ' + product.renk}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{ marginBottom: 0.5 }}
                                    className={`${SCS.decisionField} ${SCS.decisionFieldBarkod}`}
                                    data-barkod={product?.barkod}
                                >
                                    <b> Barkod&nbsp;:&nbsp;</b> {product.barkod}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{ marginBottom: 0.5 }}
                                    className={`${SCS.decisionField} ${SCS.decisionFieldAd}`}
                                    data-ad={product?.ad}
                                >
                                    <b> Ad&nbsp;:&nbsp;</b>
                                    {product.ad}
                                </Typography>
                                {product.karar.toLowerCase().includes('geri') === true ? (
                                    <Typography
                                        variant="body2"
                                        sx={{ marginBottom: 0.5 }}
                                        className={`${SCS.decisionField} ${SCS.decisionFieldKarar} ${SCS.decisionFieldKararGeri}`}
                                        data-karar={product?.karar}
                                        data-karar-type="geri"
                                    >
                                        <b> Karar&nbsp;:&nbsp;</b> <i style={{ color: 'red' }}>{product.karar}</i>
                                    </Typography>
                                ) : (
                                    <Typography
                                        variant="body2"
                                        sx={{ marginBottom: 0.5 }}
                                        className={`${SCS.decisionField} ${SCS.decisionFieldKarar} ${SCS.decisionFieldKararOther}`}
                                        data-karar={product?.karar}
                                        data-karar-type="other"
                                    >
                                        <b> Karar&nbsp;:&nbsp;</b> <i style={{ color: 'blue' }}>{product.karar}</i>
                                        <span style={{ color: 'red', marginLeft: '6px', fontSize: '12px' }}>
                                            (İlgili işlemin farklı bir mağazada iadesi yapılmış olabilir, lütfen iade
                                            almadan önce Retail Store üzerinden durumunu kontrol ediniz veya ilgili Tüke
                                            fişini kesen mağaza ile iletişime geçiniz.)
                                        </span>
                                    </Typography>
                                )}
                                <Typography
                                    variant="body2"
                                    sx={{ marginBottom: 0.5 }}
                                    className={`${SCS.decisionField} ${SCS.decisionFieldKararVeren}`}
                                    data-karar-veren={product?.kararVeren}
                                >
                                    <b> Karar Veren&nbsp;:&nbsp;</b>
                                    {product.kararVeren}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{ marginBottom: 0.5 }}
                                    className={`${SCS.decisionField} ${SCS.decisionFieldKararTarih}`}
                                    data-karar-tarih={product?.kararTarih}
                                >
                                    <b> Karar Tarihi&nbsp;:&nbsp;</b>
                                    {product.kararTarih}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{ marginBottom: 0.5 }}
                                    className={`${SCS.decisionField} ${SCS.decisionFieldNeden}`}
                                    data-neden={product?.neden}
                                >
                                    <b> Neden&nbsp;:&nbsp;</b>
                                    {product.neden}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{ marginBottom: 0.5 }}
                                    className={`${SCS.decisionField} ${SCS.decisionFieldSonucBilgi}`}
                                    data-sonuc-bilgi={product?.sonucBilgi}
                                >
                                    <b>Sonuç Bilgi&nbsp;:&nbsp;</b> {product.sonucBilgi}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{ marginBottom: 0.5 }}
                                    className={`${SCS.decisionField} ${SCS.decisionFieldGiderPusulaNo}`}
                                    data-gider-pusula-no={product?.giderPusulaNo}
                                >
                                    <b> Gider Pusula No&nbsp;:&nbsp;</b>
                                    {product.giderPusulaNo}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{ marginBottom: 0.5 }}
                                    className={`${SCS.decisionField} ${SCS.decisionFieldAciklama}`}
                                    data-aciklama={product?.aciklama}
                                >
                                    <b> Açıklama&nbsp;:&nbsp;</b>
                                    {product.aciklama}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{ marginBottom: 0.5 }}
                                    className={`${SCS.decisionField} ${SCS.decisionFieldSonucYazisi}`}
                                    data-sonuc-yazisi={musteriIadeUrun?.sonucYazisi}
                                >
                                    <b> Sonuç Yazısı&nbsp;:&nbsp;</b>
                                    {musteriIadeUrun.sonucYazisi}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
        </Grid>
    );
};
